import { Component, HostListener } from '@angular/core';
import {
  DEFAULT_LANG_CODE,
  DEFAULT_LANG_FILE,
  SUPPORTED_LANGUAGES,
} from './components/language/language.const';
import { AuthService } from './auth/services/auth/auth.service';
import { NavigationEnd, Router, Event as RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './core/services/user/user.service';
import { StorageService } from './core/services/storage/storage.service';
import { STORAGE } from './core/enums/storage';
import { ROUTES } from './app.routes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected title = 'gearbox-webapp';
  isConfigLoaded: boolean = false;
  isAuthenticated: boolean;
  showHeader: boolean = true;
  supportedLanguages: string[] = SUPPORTED_LANGUAGES;
  constructor(
    private authService: AuthService,
    private router: Router,
    private translateService: TranslateService,
    private storageService: StorageService,
  ) {
    console.log(
      `%c Browser location -  ${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      'background: lightgreen; color: grey'
    );
    /** code to hide the header & sidenav for login page & forgot password page */
    // this.router.events.subscribe((event: Event) => {
    //   if (event instanceof NavigationEnd) {
    //     if (['/', ROUTES.login, ROUTES.resetPwd, ROUTES.updatePassword].includes(event.url) || event.url.includes(ROUTES.register) || event.url.includes(ROUTES.resetPwdOTP)) {
    //       this.showHeader = false;
    //     } else {
    //       this.showHeader = true;
    //     }
    //   }
    // });
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        if (
          ['/', ROUTES.login, ROUTES.resetPwd, ROUTES.updatePassword].includes(
            event.url
          ) ||
          event.url.includes(ROUTES.register) ||
          event.url.includes(ROUTES.resetPwdOTP)
        ) {
          this.showHeader = false;
        } else {
          this.showHeader = true;
        }
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])


  async ngOnInit() {
    this.authService.handleRedirectCallback();
    const scale = window.devicePixelRatio;
    if (scale > 1) {
      document.body.style.setProperty('--ui-scale', (1 / scale).toString());
    }

    if (this.storageService.getConfig()?.baseAuthUrl) {
      this.isConfigLoaded = true;

      this.translateService.setDefaultLang(DEFAULT_LANG_FILE);

      // Set en-GB as language on logout
      if (!this.isAuthenticated) {
        this.translateService.setDefaultLang(DEFAULT_LANG_FILE);
      }
      this.translateService.addLangs(this.supportedLanguages);
    }
  }
}
